import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function AdminCandidateModal({ data, onClose }: any) {
  const locationPath = useLocation(); // ✅ selalu dipanggil
  const currentLang = locationPath.pathname.startsWith("/id") ? "id" : "en";

  const t = (obj?: any) => {
    if (!obj) return "-";
    if (typeof obj === "string") return obj;
    return obj[currentLang] || obj.en || "-";
  };

  if (!data) return null; // 
  const candidate = data.candidate;
  const applied = data.applied_at;


  const formatDate = (date?: string) => {
    if (!date) return "-";

    const d = new Date(date);

    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
  };


  return (
    <div
      className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl w-full max-w-4xl p-6 shadow-lg overflow-y-auto max-h-[90vh] relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-2xl font-semibold"
        >
          ✕
        </button>

        {/* Header */}
        <div className="flex gap-5 border-b pb-5">
          <img
            src={candidate.photo || "https://placehold.co/150"}
            alt={candidate.name}
            className="w-32 h-32 rounded-xl object-cover border"
          />

          <div className="flex flex-col gap-1">
            <h2 className="text-2xl font-semibold">{candidate.name}</h2>
            <p className="text-primary font-medium">{candidate.email || "-"}</p>

            <div className="text-gray-600 text-sm flex flex-col gap-1 mt-1">
              <p>{candidate.phone}</p>
              <p>{`${candidate.country_name || "-"}, ${candidate.state_name || "-"}, ${candidate.city_name || "-"}`}</p>
              <p>Applied at: {formatDate(applied)}</p>
            </div>
          </div>
        </div>

        {/* About Me */}
        {candidate.about && (
          <section className="mt-6">
            <h3 className="font-semibold text-lg mb-2">About Me</h3>
            <p className="text-sm text-gray-700">{t(candidate.about)}</p>
          </section>
        )}

        {candidate.skills && candidate.skills.length > 0 && (
          <section className="mt-6">
            <h3 className="font-semibold text-lg mb-3">Skills</h3>

            <div className="flex flex-wrap gap-2">
              {candidate.skills.map(
                (
                  skill: {
                    id: number;
                    name: string;
                  }
                ) => (
                  <span
                    key={skill.id}
                    className="px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium"
                  >
                    {skill.name}
                  </span>
                )
              )}
            </div>
          </section>
        )}



        {/* Basic Info */}
        <div className="mt-6">
          <h3 className="font-semibold text-lg mb-3">Basic Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InfoBox label="Date of Birth" value={candidate.birth_date ? new Date(candidate.birth_date).toLocaleDateString() : "-"} />
            <InfoBox label="Gender" value={t(candidate.gender_name) || "-"} />
            <InfoBox label="Degree" value={t(candidate.degree_name) || "-"} />
            <InfoBox label="Martial Status" value={t(candidate.martial_status_name) || "-"} />
            <InfoBox label="Notice Period" value={t(candidate.join_availability_name) || "-"} />
            <InfoBox label="Join Availability" value={t(candidate.join_availability_name) || "-"} />
            <InfoBox label="Years of Experience" value={t(candidate.experience_year_name) || "-"} />
            <InfoBox label="Levels of Experience" value={t(candidate.experience_level_name) || "-"} />
            <InfoBox label="Available Hiring" value={candidate.available_for_hiring ? "✅" : "❌"} />
            <InfoBox label="Negotiable Salary" value={candidate.is_negotiable ? "✅" : "❌"} />
          </div>
        </div>

        {/* Languages */}
        {candidate.languages && candidate.languages.length > 0 && (
          <section className="mt-6">
            <h3 className="font-semibold text-lg mb-3">Languages</h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {candidate.languages.map(
                (
                  lang: {
                    id: number;
                    name: Record<string, string>;
                    proficiency: {
                      id: number;
                      name: Record<string, string>;
                    };
                  },
                  index: number
                ) => (
                  <div key={lang.id ?? index} className="border rounded-lg p-3 text-sm">
                    <p className="text-gray-800 font-medium">
                      {t(lang.name)}
                    </p>
                    <p className="text-gray-500 mt-1">
                      Proficiency: {t(lang.proficiency?.name)}
                    </p>
                  </div>
                )
              )}
            </div>
          </section>
        )}


        {/* Salary */}
        <section className="my-6">
          <h3 className="font-semibold text-lg mb-3 flex items-center">Salary
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="border rounded-xl p-4 bg-gray-50">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
                Current Salary
              </p>
              <p className="text-sm text-gray-800">
                {candidate.current_salary ? `Rp ${candidate.current_salary.toLocaleString()}` : "-"} - {candidate.current_salary_method}
              </p>
            </div>

            <div className="border rounded-xl p-4 bg-gray-50">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
                Expected Salary
              </p>
              <p className="text-sm text-gray-800">
                {candidate.expected_salary ? `Rp ${candidate.expected_salary.toLocaleString()}` : "-"} - {candidate.expected_salary_method}
              </p>
            </div>
          </div>
        </section>

        {/* Resume */}
        <InfoBox label="Portfolio Link" value={candidate.website || "-"} />
        <button
          onClick={() => window.open(candidate.resume || data.resume_path, "_blank")}
          className="mt-10 bg-primary text-white w-full py-3 rounded-lg font-medium hover:bg-primary/90"
        >
          View Resume / CV
        </button>
      </div>
    </div>
  );
}

function InfoBox({ label, value }: any) {
  return (
    <div className="border rounded-lg p-3 text-sm">
      <p className="text-gray-500 text-sm font-medium">{label}</p>
      <p className="text-gray-800 mt-1 text-base">{value || "-"}</p>
    </div>
  );
}

